import { useState, useEffect } from "react";
import { getCountryList, getLangSetting, getSiteSetting } from "../services/user-services";


export function useFetchSetting(siteID){
    const [Result, setData] = useState(null);
    const [error, setError] = useState(false);
    const [loading, setLoding] = useState(false);

    useEffect(() => {
        let res = 273;
        if (!isNaN(siteID)){
            res = siteID;
        }
        const getData = async () =>{
            setLoding(true);
            const data = await getSiteSetting(res);
            setData(data);
            setLoding(false);
            setError(false);
        }
        getData();
    }, [siteID]);

    return [Result, loading, error];
}

export function useFetchLang(lang){
    const [Result, setData] = useState(null);
    const [error, setError] = useState(false);
    const [loading, setLoding] = useState(false);
    var selectLang = '';
    if(lang){
        selectLang = `${lang}/`
    }
    useEffect(() => {
        const getData = async () =>{
            setLoding(true);
            const data = await getLangSetting(selectLang);
            setData(data);
            setLoding(false);
            setError(false);
        }
        getData();
    }, [lang]);

    return [Result, loading, error];
}

export function useFetchCountry(){
    const [Result, setData] = useState(null);
    const [error, setError] = useState(false);
    const [loading, setLoding] = useState(false);
    
    useEffect(() => {
        const getData = async () =>{
            setLoding(true);
            const data = await getCountryList();
            
            setData(data);
            setLoding(false);
            setError(false);
        }
        getData();
    }, []);

    return [Result, loading, error];
}
